import { NavLink } from "react-router-dom";
import { BookOpen, ClipboardList, Music, Settings, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

// Admin panel sekme sırası: Talepler → Rehber İçeriği → Duygusal Sebep → Meditasyon
// Müziği → Ayarlar. Talepler en üstte (2026-07-31) — en sık kontrol edilecek
// operasyonel sayfa (ödeme/meditasyon üretim akışı), Rehber İçeriği'nin bile üstünde.
// Ayarlar en altta (2026-08-01) — nadiren değiştirilen, yapılandırma amaçlı bir sayfa.
// Yol öneki 2026-07-30'da /admin/selma'dan /selma'ya değişti (numeroloji.app/selma).
//
// "Frekans Setleri" 2026-07-30'da menüden bilinçli olarak kaldırıldı — Numeroloji'nin
// gerçek sinüs dalga/binaural beat sentezleme motoruyla doğru şekilde yeniden ele
// alınana kadar askıya alındı. Route/sayfa/backend SİLİNMEDİ, bkz. CLAUDE.md. Geri
// açmak için aşağıdaki satırı LINKS'e ekle (icon: AudioLines, lucide-react'ten import et):
// { to: "/selma/frekans-setleri", label: "Frekans Setleri", icon: AudioLines },
const LINKS = [
  { to: "/selma/talepler", label: "Talepler", icon: ClipboardList },
  { to: "/selma/rehber", label: "Rehber İçeriği", icon: BookOpen },
  { to: "/selma/duygusal-sebep", label: "Duygusal Sebep", icon: Sparkles },
  { to: "/selma/meditasyon-muzikleri", label: "Meditasyon Müziği", icon: Music },
  { to: "/selma/ayarlar", label: "Ayarlar", icon: Settings },
] as const;

export function SelmaAdminSidebar() {
  return (
    <aside className="hidden w-60 flex-none border-r border-slate-200 bg-white/80 p-4 md:block">
      <div className="mb-6 px-2 text-lg font-bold tracking-tight text-slate-900">Selma</div>
      <nav className="flex flex-col gap-1">
        {LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2.5 rounded-xl px-3 py-2 text-sm font-semibold transition-colors",
                isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100",
              )
            }
          >
            <link.icon className="h-4 w-4" />
            {link.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export function SelmaAdminMobileNav() {
  return (
    <nav className="flex items-center gap-1 overflow-x-auto md:hidden">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          className={({ isActive }) =>
            cn(
              "flex flex-none items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors",
              isActive ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600",
            )
          }
        >
          <link.icon className="h-3.5 w-3.5" />
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}
